import { END_POINT } from 'config/environment';
import { ITalentInvites } from 'features/invites/types';
import { useGetUserInfo } from 'hooks/useGetUserInfo';
import { useQuery } from 'react-query';



export const QUERY_KEY_FOR_TALENT_JOB_FOR_RECRUITER =
    "talent-job-invites-for-recruiter";

const getInvites = async (
    status: 'accepted' | 'pending' | 'rejected',
    token: string,
    userInfo: any
): Promise<ITalentInvites[]> => {
    const corporate_id = userInfo?.current_team ? userInfo?.current_team.corporate_id : null;

    const url = corporate_id
        ? `${END_POINT.BASE_URL}/v1/recruiter-invites/${status}/${corporate_id}`
        : `${END_POINT.BASE_URL}/v1/recruiter-invites/${status}`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
    const res = await fetch(url, config);
    const data = await res.json();
    return data;
}


export const useGetInvitesByStatus = (
    status: 'accepted' | 'pending' | 'rejected'
) => {
    const { token, userInfo } = useGetUserInfo();

    return useQuery(
        [QUERY_KEY_FOR_TALENT_JOB_FOR_RECRUITER, status, userInfo?.current_team?.corporate_id],
        () => getInvites(status, token, userInfo),
        {
            enabled: !!token && !!status,
            staleTime: 1000 * 60 * 5,
        }
    );
};
